export default __webpack_public_path__ + "static/media/GovNpoSciCodebook.449d6d09.pdf";